/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} pts transfer penalty`)
};

const es_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} pts de penalización por traspasos`)
};

const de_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} Pkt. Transferstrafe`)
};

const nl_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} ptn transferstraf`)
};

const fr_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} pts de pénalité de transfert`)
};

const it_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} pt di penalità trasferimenti`)
};

const pt_br2_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} pts de penalidade por transferências`)
};

const pt_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`−${i?.points} pts de penalização por transferências`)
};

const ja_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`移籍ペナルティ −${i?.points} pts`)
};

const zh_f1_myteam_penalty = /** @type {(inputs: { points: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`转会罚分 −${i?.points} 分`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ points: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_penalty = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_penalty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_penalty", locale)
	if (locale === "en") return en_f1_myteam_penalty(inputs)
	if (locale === "es") return es_f1_myteam_penalty(inputs)
	if (locale === "de") return de_f1_myteam_penalty(inputs)
	if (locale === "nl") return nl_f1_myteam_penalty(inputs)
	if (locale === "fr") return fr_f1_myteam_penalty(inputs)
	if (locale === "it") return it_f1_myteam_penalty(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_penalty(inputs)
	if (locale === "pt") return pt_f1_myteam_penalty(inputs)
	if (locale === "ja") return ja_f1_myteam_penalty(inputs)
	return zh_f1_myteam_penalty(inputs)
};